<template>
  <div style="overflow: hidden">
    <div id="data-view">
      <dv-full-screen-container>
        <div id="top-header">
          <div class="header-left-decoration">
            <dv-decoration-8/>
            <div class="header-left">
              <el-select @change="changeProduct($event)" filterable v-model="deviceDefault">
                <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in deviceBoards">
                  <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                  {{ item.name }}
                </el-option>
              </el-select>
            </div>
            <div class="header-left-wind" :style="setTGDisplay()">
              <div class="header-wind-container">
                <div class="head-wind-left">
                  <p class="head-wind-left-container">{{$t('vapor')}}</p>
                </div>
                <div class="header-wind-right">
                  <p class="header-wind-right-container">{{vapor}}</p>
                </div>
              </div>
              <div class="header-wind-container">
                <div class="head-wind-left">
                  <p class="head-wind-left-container">{{$t('WindGust')}}</p>
                </div>
                <div class="header-wind-right">
                  <p class="header-wind-right-container">{{windMaxValue.value}}m/s</p>
                </div>
              </div>
            </div>
          </div>
          <dv-decoration-5 class="header-center-decoration"/>
          <!--        <dv-decoration-8 :reverse="true" class="header-right-decoration"/>-->
          <div class="header-right-decoration">
            <div class="header-left":style="setDisplay()">
              <div class="header-weather-left">
                <p ><img :src="srcWeather"></p>
                <p>{{weatherAddress}}</p>
              </div>
              <div class="header-weather-right">
                <p>{{nowTime}}&emsp;{{type}}</p>
                <div>
                  <p>温度： {{lowTemp}}&emsp;~&emsp;{{highTemp}}</p>
                  <p>风向：{{windDirection}}&emsp;风力：{{windPower}}</p>
                </div>
              </div>
            </div>
            <div class="header-left-TG" :style="setTGDisplay()">
              <div class="header-TG-container">
                <div class="header-TG-left">
                  <p class="header-TG-left-container">{{$t('strike')}}</p>
                </div>
                <div class="header-TG-right">
                  <p class="header-TG-right-container">0</p>
                </div>
              </div>
              <div class="header-TG-container">
                <div class="header-TG-left">
                  <p class="header-TG-left-container">{{$t('average')}}</p>
                </div>
                <div class="header-TG-right">
                  <p class="header-TG-right-container">0</p>
                </div>
              </div>
            </div>
            <dv-decoration-8 :reverse="true"/>
            <div class="header-right">
              <el-button @click="logout" style="color: #51b9fb;font-size: 14px">{{$t("logout")}}</el-button>
              <div class="header-button">
                {{emial}}
              </div>
            </div>
          </div>
          <div class="center-title">{{$t("cloudPlatform")}}</div>

        </div>
        <div class="main-content">
          <digital-top @callBackInfo="handleInfo" ref="digitalTop"/>

          <div class="block-left-right-content">
            <ranking-board :lineInfo="offLine" ref="rankingBoard"/>

            <div class="block-top-bottom-content">
              <div class="block-top-content">
                <!--              <rose-chart ref="roseChart"/>-->

                <!--              <water-level-chart ref="waterLevelChart"/>-->
                <center-map @callBackInfo="getConnectionTime" ref="centerMap"/>

                <scroll-board ref="scrollBoard"/>
              </div>

              <!--            <cards ref="cards"/>-->
              <div class="rmc-bottom-container">
                <bottom-chart :partInfo="telemetryKey" ref="bottomChart"/>
              </div>
            </div>
          </div>
        </div>
      </dv-full-screen-container>
    </div>
  </div>

</template>

<script>
  import digitalTop from "./DigitalTop";
  import rankingBoard from "./RankingBoard";
  // import roseChart from "./RoseChart";
  // import waterLevelChart from "./WaterLevelChart";
  // import cards from "./Cards";
  import scrollBoard from "./ScrollBoard";
  import centerMap from "./CenterMap";
  import bottomChart from "./BottomChart";
  import axios from "axios";
  import {
    getAttributesServer,
    getAttributesShared, getConnectTime,
    getCredentials,
    getCustomerDevice,
    getDeviceKey,
    getDevicesInfo,
    getDeviceValue, getTimeDeviceHistory
  } from "../untils/api/home";
  import router from "../router/index"
  import moment from "moment";
  import {userLogin} from "../untils/api/login";

  export default {
    name: 'Home',
    components: {
      digitalTop,
      rankingBoard,
      scrollBoard,
      centerMap,
      bottomChart
    },
    data() {
      return {
        deviceBoards: [],
        deviceDefault: '',
        deviceInfo: null,
        emial: '',
        flg: true,
        deviceId: '',
        latestTelemetryStr: '',
        telemetryKey: [],
        telemetryResponse: {},
        clientResStr: '',
        time: null,
        tokenTime: null,
        offLine: 0,
        nowTime:'',
        highTemp: '',
        lowTemp: '',
        windDirection: '',
        windPower: '',
        type: '',
        srcWeather: require('./img/wether1.png'),
        weatherAddress: '',
        weatherCode: '',
        msg: null,
        TG: false,
        windMaxValue: {},
        vapor:0,
      }
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.deciphering(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.deciphering(localStorage.getItem('customerId')) : this.$route.params.customerId;
      //获取用户名
      //this.emial = this.$route.params.email === undefined ? localStorage.getItem('email') : this.$route.params.email;
      this.emial = this.$route.params.email === undefined ? this.$commonFun.deciphering(localStorage.getItem('email')): this.$route.params.email;
      //用户为租户管理员
      if (authority === 'TENANT_ADMIN') {
        //获取设备列表 存放在数组
        getDevicesInfo().then(response => {
          //设置设备列表
          this.setDeviceBoards(response, authority);
        }).catch(error => {
          console.log("error", error)
        })
      } else {
        //用户为租户
        getCustomerDevice(customerId).then(response => {
          //设置设备列表
          this.setDeviceBoards(response, authority);
        }).catch(error => {
          console.log("error", error);
        })
      }

      // this.msg = this.$message({
      //   showClose: true,
      //   type: 'warning',
      //   message: '尊敬的客户，我们将于2024年5月15日删除2024年3月13日之前的历史数据，请有需求的客户请及时存储。给您带来的不便，深感抱歉',
      //   duration: 1000 * 60
      // })

      // this.$confirm(
      //   '尊敬的客户：我们将于2025年7月4日删除2025年7月4日之前的历史数据，请有需求的客户请及时存储。给您带来的不便，深感抱歉！',
      //   '提示',
      //   {
      //     confirmButtonText: '确定',
      //     type: 'warning',
      //     showCancelButton: false, // 隐藏取消按钮
      //     center: true,
      //     closeOnClickModal: false, // 禁止点击模态层关闭
      //     closeOnPressEscape: false, // 禁止按下 ESC 键关闭
      //   }
      // ).then(() => {
      //   // 确认后的逻辑
      // });
    },

    beforeDestroy() {
      clearInterval(this.time);
      this.time = null;
      clearInterval(this.tokenTime);
      this.tokenTime = null;

      // if(this.msg != null) {
      //   this.msg.close();
      //   this.msg = null;
      // }
    },

    methods: {
      /**
       * 设置设备列表
       * @param response
       */
      setDeviceBoards(response, authority) {
        if(authority === 'TENANT_ADMIN') {
          if (response.data.length === 0) return;
          for (let i = 0; i < response.data.length; i++) {
            let deviceOption = {};
            deviceOption.id = response.data[i].id.id;
            deviceOption.name = response.data[i].name;
            deviceOption.type = response.data[i].id.entityType;
            this.deviceBoards.push(deviceOption);
          }

          // //设置默认选中的设备
          this.deviceDefault = this.deviceBoards[0].id;

          if(localStorage.getItem('deviceName') !== null) {
            let deviceJson = this.$commonFun.deciphering(localStorage.getItem('deviceName'));
            for(let i = 0; i < this.deviceBoards.length; i++) {
              if(this.deviceBoards[i].name === deviceJson) {
                this.deviceDefault = this.deviceBoards[i].id;
                break;
              }
            }
          }

          this.getDeviceToken();
          //根据选中的值获取设备数据
          this.getDashInfo();
          localStorage.setItem("upLowList",null);
          this.$refs.rankingBoard.setTotalDevice(this.deviceBoards.length,this.deviceDefault);
          this.$refs.rankingBoard.getLeftCredentialsInfo(this.deviceDefault);
          // this.$refs.scrollBoard.getCredentialsInfo(this.deviceDefault);
        } else {
          if (response.data.length === 0) return;
          let promises = [];

          let count = response.data.length;
          let onLine = 0;

          for (let i = 0; i < response.data.length; i++){
            let deviceOption = {
              id: response.data[i].id.id,
              name: response.data[i].name,
              type: response.data[i].id.entityType
            };

            let promise = getAttributesServer(deviceOption.type, deviceOption.id).then(response => {
              let lastConnect = response.find(attr => attr.key === 'lastConnectTime');
              let lastActivity = response.find(attr => attr.key === 'lastActivityTime');
              let time = lastConnect != undefined ? lastConnect.value : lastActivity.value;
              let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
              //deviceOption.state = time < beforeTime ? 'red' : 'green';
              if(time < beforeTime) {
                deviceOption.state = 'red';
              } else {
                deviceOption.state = 'green';
                onLine++
              }
              return deviceOption
            });

            promises.push(promise);
          }

          Promise.all(promises).then(results => {
            this.deviceBoards = results;

            // //设置默认选中的设备
            this.deviceDefault = this.deviceBoards[0].id;

            if(localStorage.getItem('deviceName') !== null) {
              let deviceJson = this.$commonFun.deciphering(localStorage.getItem('deviceName'));
              for(let i = 0; i < this.deviceBoards.length; i++) {
                if(this.deviceBoards[i].name === deviceJson) {
                  this.deviceDefault = this.deviceBoards[i].id;
                  break;
                }
              }
            }

            this.getDeviceToken();
            //根据选中的值获取设备数据
            this.getDashInfo();
            localStorage.setItem("upLowList",null);
            console.log("111111", onLine)
            this.$refs.rankingBoard.setTotalDevice(count, onLine);
            this.$refs.rankingBoard.getLeftCredentialsInfo(this.deviceDefault);
            // this.$refs.scrollBoard.getCredentialsInfo(this.deviceDefault);
          })
        }
      },

      getDeviceToken(){
        this.tokenTime = window.setInterval(() => {
          setTimeout(() => {
            this.getWeatherInfo();
            //let paramJsom =  JSON.parse(localStorage.getItem('login'));
            let paramJson = JSON.parse(this.$commonFun.deciphering(localStorage.getItem('login')));
            userLogin(paramJson).then(response => {
              //localStorage.setItem('token', response.token);
              localStorage.setItem('token', this.$commonFun.encryption(response.token));
            }).catch(error => {
            }).catch(error => {
              console.log("error", error);

            })
          }, 0)
        },1000 * 60 * 60 * 2);
      },

      /**
       * 获取选中的设备
       * @param event
       */
      changeProduct(event) {
        this.deviceDefault = event;
        console.log("选中的设备：", this.deviceDefault);
        clearInterval(this.time);
        this.time = null;
        this.clientResStr = '';
        localStorage.setItem("upLowList",null);
        this.getDashInfo();
        this.$refs.rankingBoard.getLeftCredentialsInfo(this.deviceDefault);
        this.$refs.scrollBoard.getCredentialsInfo(this.deviceDefault);
      },

      /**
       * 根据选中的值获取设备数据
       * @param devicesInfo
       */
      getDashInfo() {
        //访问api获取设备信息
        getCredentials(this.deviceDefault).then(response => {
          //根据设备id获取亚遥测数据key值
          this.getDeviceKeyInfo(response.deviceId);
          this.deviceInfo = response.deviceId;
          //获取天气预报地址
          this.getSharedData(response.deviceId);
          this.getServerData(response.deviceId);

        }).catch(error => {
          console.log("error", error)
        });
        this.time = window.setInterval(() => {
          setTimeout(() => {
            //访问api获取设备信息
            getCredentials(this.deviceDefault).then(response => {
              //根据设备id获取亚遥测数据key值
              this.getDeviceKeyInfo(response.deviceId);
              // this.getClientInfo(response.deviceId, response.credentialsId);
            }).catch(error => {
              console.log("error", error)
            })
          }, 0)
        }, 1000 * 60);
      },

      /**
       * 获取天气预报地址
       * @param deviceId
       */
      getSharedData(deviceId) {
        this.weatherCode = '';
        this.weatherAddress = '';
        localStorage.setItem('levelRefer', 0);
        localStorage.setItem('snowRefer', 0);
        localStorage.setItem("emptyHRefer", 0);
        localStorage.setItem('noiseRefer', 0);
        localStorage.setItem("CODJson", null);
        localStorage.setItem("waterFlg", null);
        localStorage.setItem("cumFlow", null);
        getAttributesShared(deviceId.entityType, deviceId.id).then(response => {
          for(let i = 0; i < response.length; i++){
            if(response[i].key === "weather_address"){
              this.weatherCode = response[i].value;
              //获取天气预报信息
              this.getWeatherInfo()
            } else if(response[i].key === "level_refer") {
              localStorage.setItem('levelRefer', response[i].value);
            } else if(response[i].key === 'snow_refer') {
              localStorage.setItem('snowRefer', response[i].value);
            } else if(response[i].key == 'emptyH_refer') {
              localStorage.setItem("emptyHRefer", response[i].value);
            } else if(response[i].key == 'noise_refer') {
              localStorage.setItem('noiseRefer', response[i].value);
            } else if(response[i].key == 'CODJson'){
              localStorage.setItem("CODJson", response[i].value);
            } else if(response[i].key == 'waterFlg') {
              localStorage.setItem("waterFlg", response[i].value);
            } else if(response[i].key == 'cumFlow') {
              localStorage.setItem("cumFlow", response[i].value);
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      getServerData(deviceId) {
        localStorage.setItem("fx", null);
        localStorage.setItem("HI", null);
        localStorage.setItem("TG", null);
        localStorage.setItem("WD", null);
        this.TG = false;
        getAttributesServer(deviceId.entityType, deviceId.id).then(response => {
          for(let i = 0; i < response.length; i++){
            if(response[i].key == 'fx') {
              localStorage.setItem("fx", response[i].value);
              continue;
            } else if(response[i].key == 'HI') {
              localStorage.setItem("HI", response[i].value);
              continue;
            } else if(response[i].key == 'TG') {
              this.TG = true;
              this.getWindSpeed();
              localStorage.setItem("TG", response[i].value);
              continue;
            } else if(response[i].key == 'WD') {
              localStorage.setItem("WD", response[i].value);
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取天气预报地址
       */
      async getWeatherInfo() {
        if(this.weatherCode !== ''){
          //let url = 'weather_mini?city=' + this.weatherAddress;
          let url = 'weather/city/' + this.weatherCode;
          return await axios({
            method: 'get',
            baseURL: process.env.Weather, // 修改这里
            url,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            timeout: 10000
          }).then((response) => {
            this.nowTime = moment().format("YYYY-MM-DD");
            this.weatherAddress = response.cityInfo.city.toString().substring(0, response.cityInfo.city.length - 1);
            this.highTemp = response.data.forecast[0].high.toString().split(' ')[1];
            this.lowTemp = response.data.forecast[0].low.toString().split(' ')[1];
            this.windDirection = response.data.forecast[0].fx;
            this.windPower = response.data.forecast[0].fl;
            this.type = response.data.forecast[0].type;
            // this.nowTime = moment().format("YYYY-MM-DD");
            // this.highTemp = result.data.forecast[0].high.toString().split(' ')[1];
            // this.lowTemp = result.data.forecast[0].low.toString().split(' ')[1];
            // this.windDirection = result.data.forecast[0].fengxiang;
            // this.windPower = result.data.forecast[0].fengli.split('CDATA[')[1].split(']')[0];
            // this.type = result.data.forecast[0].type;
          }).catch((error) => {
            this.weatherCode = '';
            console.log("error", error)
          })
        }
      },

      setDisplay(){
        if(this.weatherCode === ''){
          return {
            // color: color
            display: 'none'
          };
        }
      },

      setTGDisplay() {
        if(this.TG == true){
          return {
            // color: color
            display: 'block'
          };
        }
      },

      /**
       * 获取遥感key值
       * @param deviceId
       */
      getDeviceKeyInfo(deviceId) {
        //访问api 获取设备key
        getDeviceKey(deviceId.entityType, deviceId.id).then(response => {
          let deviceKey = '';
          let pattern = /^[A-Za-z0-9.-_-]+$/;
          //判断key是否存在
          response.length === 0 ? deviceKey = 'false' : deviceKey = '';
          //key 存在遍历取出 转成字符串
          for (let i = 0; i <= response.length - 1; i++) {
            if (pattern.test(response[i])) {
              i === response.length - 1 ? deviceKey += response[i] : deviceKey += response[i] + ','
            }
          }

          //根据 设备id 遥测key 获取最新遥测value
          this.getLatestTelemetryData(deviceId, deviceKey);
          if (this.deviceId !== deviceId.id) {
            this.deviceId = deviceId.id;
            this.$refs.bottomChart.getSelectKey(deviceId, response);
          }

        }).catch(error => {
          console.log("error", error);
        })
      },

      /**
       * 获取最新遥测数据
       * @param deviceId
       * @param deviceKey
       */
      getLatestTelemetryData(deviceId, deviceKey) {
        //key不存在清空数据
        if (deviceKey === 'false') {
          //将值传递给RankingBoard组件
          this.$refs.rankingBoard.getDeviceValueInfo(deviceId,deviceKey);
          //将值传递给DigitalTop组件
          this.$refs.digitalTop.getDigitalTop(deviceKey);
          // 将值传递给ScrollBoard组件
          this.$refs.scrollBoard.getDevoceHistoryInfo(deviceId,deviceKey,this.deviceDefault);
          return;
        }
        //key存在访问api
        getDeviceValue(deviceId.entityType, deviceId.id, deviceKey).then(response => {
          console.log("LatestTelemetryData", response);

          if(this.TG == true && response.hasOwnProperty('windSpeed')) {
            this.windMaxValue = response['windSpeed'][0];
            this.maxWindSpeed(response['windSpeed'][0]);
          }
          if(this.TG == true && response.hasOwnProperty('pressure')) {
            this.vapor = response['pressure'][0].value;
          }
          //console.log("111111", response['windScale'],JSON.stringify(this.windMaxValue) == '{}')
          if (JSON.stringify(response) !== this.latestTelemetryStr) {
            this.latestTelemetryStr = JSON.stringify(response);
            this.telemetryResponse = response;
            if(localStorage.getItem('waterFlg') == "water") {
              response["Amnitro"][0].value = this.calculateWater(0,8,parseFloat(response["Amnitro"][0].value)).toFixed(2);
              response["dissolvedoxygen"][0].value = this.calculateWater(2, 10, parseFloat(response["dissolvedoxygen"][0].value)).toFixed(2);
              response["Opacity"][0].value = this.calculateWater(251, 1000, parseFloat(response["Opacity"][0].value)).toFixed(0);
              response["oRp"][0].value = this.calculateWater(50, 500, parseFloat(response["oRp"][0].value)).toFixed(0);
            }

            //将值传递给RankingBoard组件
            this.$refs.rankingBoard.getDeviceValueInfo(deviceId, response);
            //将值传递给DigitalTop组件
            this.$refs.digitalTop.getDigitalTop(response);
            //将值传递给CenterMap组件
            this.$refs.centerMap.getDeviceDataInfos(deviceId, response);
            // 将值传递给ScrollBoard组件
            this.$refs.scrollBoard.getDevoceHistoryInfo(deviceId, response,this.deviceDefault);
          }
          //初始化时只执行一次
          if (this.flg) {
            this.flg = false;
            //向centerMap组件传递设备信息
            this.$refs.centerMap.getDeviceInfos(this.deviceBoards);
          }

        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取DigiTop组件点击的值
       * @param data
       */
      handleInfo(data) {
        this.telemetryKey = data;
      },

      calculateWater(min, max, value) {
        value = Math.abs(value);
        if(value == 0) value += 1;
        if (value >= min && value <= max) {
          return value; // 直接返回原值
        }

        if (value < min) {
          let multiplier = 2;
          while (value < min) {
            value *= multiplier;
            if (value >= min) break;
            multiplier = Math.min(multiplier + 1, max / min); // 限制 multiplier 递增幅度
          }
        } else if (value > max) {
          let divisor = 2;
          while (value > max) {
            value /= divisor;
            if (value <= max) break;
            divisor = Math.min(divisor + 1, max / min); // 限制 divisor 递增幅度
          }
        }

        return Math.min(Math.max(value, min), max); // 确保最终值在区间内
      },

      /**
       * 获取在线值
       * @param data
       */
      getConnectionTime(data) {
        this.offLine = data;
      },

      getWindSpeed() {
        let startTime = moment().startOf('day').valueOf();
        let endTime = moment().valueOf();
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, 'windSpeed', startTime, endTime, 0, 'NONE').then(response => {
          let dataWind = response['windSpeed'];
         if(dataWind != undefined) {
           const maxValueObject = dataWind.reduce((maxObj, currentObj) => {
             // 将 value 属性从字符串转换为数字进行比较
             const currentValue = parseInt(currentObj.value, 10);
             const maxValue = parseInt(maxObj.value, 10);

             // 如果当前对象的 value 更大，则返回当前对象，否则返回之前的最大对象
             return currentValue > maxValue ? currentObj : maxObj;
           }, dataWind[0]);
           this.windMaxValue = {ts:new Date(moment()).getTime(), value:0};
           this.windMaxValue = maxValueObject;
         }
        }).catch(error => {
          console.log("error", error);
        })
      },

      maxWindSpeed(windSpeedJson) {
        if(Object.keys(this.windMaxValue).length === 0) {
          return;
        }
        // 获取最大风速值与时间
        let maxTime = this.windMaxValue.ts;
        let maxValue = parseInt(this.windMaxValue.value, 10); // 确保用十进制
        let nowTime = windSpeedJson.ts;
        let nowValue = parseInt(windSpeedJson.value, 10); // 确保用十进制

        // 获取用户时区
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // 格式化为当地日期
        const formatter = new Intl.DateTimeFormat('en-CA', {
          timeZone: userTimeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });

        // 将时间戳转为当地日期
        const maxTimeDate = formatter.format(new Date(maxTime));
        const nowTimeData = formatter.format(new Date(nowTime));

        // 判断是否是同一天
        if (maxTimeDate !== nowTimeData) {
          //console.log('两个时间戳在不同日期', maxTimeDate, nowTimeData);
          this.windMaxValue = windSpeedJson; // 直接更新为新的时间戳数据
        } else {
          //console.log('两个时间戳在同一天内', maxTimeDate, nowTimeData);
          // 选择较大的风速值并更新为最新的时间戳
          if (nowValue > maxValue) {
            this.windMaxValue = { ts: nowTime, value: nowValue }; // 更新时间戳和风速值为当前时间的数据
          } else {
            this.windMaxValue = { ts: nowTime, value: maxValue }; // 保持原有数据
          }
        }
      },

      /**
       * 退出
       */
      logout() {
        // if(this.msg != null) {
        //   this.msg.close();
        //   this.msg = null;
        // }
        let local = localStorage.getItem('locale');
        localStorage.clear();
        clearInterval(this.tokenTime);
        this.tokenTime = null;
        clearInterval(this.time);
        this.time = null;
        localStorage.setItem('locale',local)
        router.replace('/')
      },
    }
  }
</script>

<style lang="less">
  @import "less/home.less";
  @import "less/topHeader";
</style>

<style>
  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue